module.exports = __webpack_public_path__ + "img/discuss-screen-en.00326894.png";